export const Representatives = {
  pipeTech: {
    logoSrc: "pipeTech.png",
    logoHeight: "161px",
    logoWidth: "337px",
    logoAlt: "Pipe Tech Logo",
    location: "Louisiana & Mississippi",
    email: "frankiv@pipetechinc.com",
    phone: "985 - 807 - 8898",
    phonePrefill: "tel:9858078898",
  },
  dAndHWaterSystems: {
    logoSrc: "dAndHWaterSystems.png",
    logoHeight: "61px",
    logoWidth: "425px",
    logoAlt: "D&H Water Systems Logo",
    location: "Southern California, Southern Nevada, Arizona & New Mexico",
    email: "melanie@dandhwatersystems.com",
    phone: "760 - 722 - 6893",
    phonePrefill: "tel:7607226893",
  },
  dAndHWaterSystemsNorcal: {
    logoSrc: "dAndHWaterSystems.png",
    logoHeight: "61px",
    logoWidth: "425px",
    logoAlt: "D&H Water Systems Logo",
    location: "Northern California & Northern Nevada",
    email: "kyle@dandhwatersystems.com",
    phone: "650 - 613 - 2470",
    phonePrefill: "tel:6506132470",
  },
  bigWave: {
    logoSrc: "bigWave.png",
    logoHeight: "150px",
    logoWidth: "306px",
    logoAlt: "Big Wave Water Technologies logo",
    location: "Contact us for more info.",
    email: "kevin@bigwavewater.com",
    phone: "760 - 717 - 2249",
    phonePrefill: "tel:7607172249",
  },
  macaulay: {
    logoSrc: "macaulay.png",
    logoHeight: "114px",
    logoWidth: "342px",
    logoAlt: "Macaulay Controls Company Logo",
    location: "Texas & Oklahoma",
    email: "info@macaulaycontrols.com",
    phone: "800 - 299 - 1148",
    phonePrefill: "tel:8002991148",
  },
  miscoInter: {
    logoSrc: "misco.png",
    logoHeight: "160px",
    logoWidth: "170px",
    logoAlt: "Misco Water Logo",
    location: "Wyoming & Colorado",
    email: "smarshall@miscowater.com",
    phone: "303 - 309 - 6150",
    phonePrefill: "tel:3033096150",
  },
  tmg: {
    logoSrc: "tmg.png",
    logoHeight: "86px",
    logoWidth: "138px",
    logoAlt: "TMG Services Logo",
    location: "Oregon, Washington, Idaho, Montana & Alaska",
    email: "tmg@tmgservices.net",
    phone: "253 - 779 - 4160",
    phonePrefill: "tel:2537794160",
  },
  tc: {
    logoSrc: "tc.png",
    logoHeight: "115px",
    logoWidth: "325px",
    logoAlt: "TC Sales and Service Logo",
    location: "Utah",
    email: "contact@tcsalesco.com",
    phone: "801 - 201 - 3121",
    phonePrefill: "tel:8012013121",
  },
  petersonAndMatz: {
    logoSrc: "petersonAndMatz.png",
    logoHeight: "74px",
    logoWidth: "400px",
    location: "Michigan, Illinois & Wisconsin",
    email: "cathy.piazza@petersonandmatz.com",
    phone: "847 - 844 - 4405",
    phonePrefill: "tel:8478444405",
  },
  sos: {
    logoSrc: "sos.png",
    logoHeight: "118px",
    logoWidth: "242px",
    location: "Tennessee",
    email: "jkbrownfield@gmail.com",
    phone: "423 - 618 - 8848",
    phonePrefill: "tel:4236188848",
  },
  hpThompson: {
    logoSrc: "hpThompson.png",
    logoHeight: "192px",
    logoWidth: "265px",
    location: "Ohio, Indiana, & Kentucky",
    email: "nraymond@hpthompson.com",
    phone: "317 - 576 - 6566",
    phonePrefill: "tel:3175766566",
  },
  mc2: {
    logoSrc: "mc2.png",
    logoHeight: "108px",
    logoWidth: "353px",
    location: "Iowa, Nebraska, South Dakota, North Dakota & Minnesota",
    email: "tomm@electricpump.com",
    phone: "800 - 383 - 7867",
    phonePrefill: "tel:8003837867",
  },
  waterStorageSolutions: {
    logoSrc: "waterStorageSolutions.png",
    logoWidth: "270px",
    logoHeight: "108px",
    location:
      "Connecticut, Maine, Massachusetts, New Hampshire, New York (excluding counties New York, Kings, Bronx, Richmond, and Queens), Rhode Island, and Vermont.",
    email: "Emcquaide@waterstoragesolutionsllc.com",
    phone: "774 - 275 - 9515",
    phonePrefill: "tel:7742759515",
  },
  cl2Solutions: {
    logoSrc: "cl2Solutions.png",
    logoWidth: "400px",
    logoHeight: "153px",
    location: "Florida & Georgia",
    email: "jason@CL2solutions.com",
    phone: "813 - 629 - 2720",
    phonePrefill: "tel:8136292720",
  },
};
